import React, { ReactElement } from 'react';
import { View } from 'react-native';
import { useTheme } from '@pulsar/core';
import { Caption3 } from 'src/components/Typography';
import { Tappable, TappableProps } from 'src/components/Tappable/Tappable';
import useStyles from './TabBar.styles';

export type TabBarItemProps = Omit<TappableProps, 'children'> & {
  icon?: ReactElement;
  label?: string;
  badge?: ReactElement;
  active?: boolean;
};

export const TabBarItem: React.FC<TabBarItemProps> = ({
  icon,
  label,
  badge,
  active = false,
  style,
  ...props
}) => {
  const s = useStyles();
  const theme = useTheme();

  return (
    <Tappable
      style={[s.tabWrapper, style]}
      accessibilityRole="tab"
      accessibilityState={{ selected: active }}
      hoverable
      {...props}
    >
      <View style={s.tabContent}>
        {icon && (
          <View style={s.iconContainer}>
            {React.cloneElement(icon, {
              color: active ? theme.colors.tabBarActive : theme.colors.tabBarInactive,
            })}
            {badge &&
              React.cloneElement(badge, {
                style: s.badge,
              })}
          </View>
        )}
        {label && (
          <Caption3 weight="regular" style={[s.text, active && s.textActive]}>
            {label}
          </Caption3>
        )}
      </View>
    </Tappable>
  );
};
